var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-field",
    {
      staticClass: "g-option",
      staticStyle: { "padding-right": "0px" },
      attrs: {
        error: _vm.$v.dValue.$error,
        "error-label": _vm.mensagemErro,
        disabled: _vm.desabilitar,
        helper: _vm.mensagemAjuda,
        label: _vm.etiqueta
      }
    },
    [
      _c("q-option-group", {
        attrs: {
          name: _vm.name,
          id: _vm.id,
          type: _vm.tipo,
          options: _vm.option,
          inline: _vm.horizontal,
          disable: _vm.desabilitar,
          value: _vm.value
        },
        on: {
          change: _vm.change,
          input: function($event) {
            _vm.atualizarModelo($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }